import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cntt-page-not-found',
    templateUrl: 'pagenotfound.component.html'
})
export class PageNotFoundComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/login/pagenotfound.component.ts